module.exports = ".green {\n\tcolor: green;\n\tfont-weight: bold;\n}"